import client from "../client"

const listing = async(params)=>{
    let res:any = await client.get("/permissions/get",params);
    return res;
}  

const create =  async (params)=>{
    let res:any = await client.post("/permissions/create",params)
    console.log(res)
    console.log(params)
    return res
}

export default {create,listing} 